"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var CmpApiModel_1=require("../CmpApiModel"),Response=function(){this.cmpId=CmpApiModel_1.CmpApiModel.cmpId,this.cmpVersion=CmpApiModel_1.CmpApiModel.cmpVersion,this.gdprApplies=CmpApiModel_1.CmpApiModel.gdprApplies,this.tcfPolicyVersion=CmpApiModel_1.CmpApiModel.tcfPolicyVersion};exports.Response=Response;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@iabtcf/cmpapi/lib/response/Response.js
// module id = 8
// module chunks = 0